module.exports = __webpack_public_path__ + "img/add_booking_icon.b3343b7d.svg";